import type { Directive } from 'vue';
import { useAuthStore } from '@/stores/auth';

function checkPermission(el: HTMLElement, codes: string[]) {
  const auth = useAuthStore();
  if (codes && codes.length > 0 && !auth.hasAnyPermission(...codes)) {
    el.style.display = 'none';
    el.dataset.permHidden = '1';
  } else if (el.dataset.permHidden === '1') {
    el.style.display = '';
    delete el.dataset.permHidden;
  }
}

export const vPermission: Directive = {
  mounted(el, binding) {
    checkPermission(el, binding.value as string[]);
  },
  updated(el, binding) {
    checkPermission(el, binding.value as string[]);
  },
};

export function registerDirectives(app: import('vue').App) {
  app.directive('permission', vPermission);
}
